import {FIELD_NAMES} from "profile/enums";
import {IProfile} from "StateInterface";

export interface ILoanProfile {
    purpose: string;
    tenure: number;
    amount: number;
}

export interface IBankAccountProfile {
    beneficiaryName: string;
    accountNumber: string;
    ifsc: string;
}

export interface ILoanBoundary {
    amount_range: number[];
    tenure_months_range: number[];
    interest_range: number[];
}

export const getLoanInitialState = (profile: IProfile): ILoanProfile =>  ({
    amount: profile.loanRequest && profile.loanRequest.amount,
    tenure: profile.loanRequest && profile.loanRequest.tenure,
    purpose: profile.loanRequest && profile.loanRequest.purpose,
});

export const getBankAccountInitialState = (profile: IProfile): IBankAccountProfile =>  {
    const state = profile.bankAccounts[profile.bankAccounts.length - 1];
    return {
        accountNumber: state && state[FIELD_NAMES.ACCOUNT_NUMBER],
        beneficiaryName: state && state[FIELD_NAMES.BENEFICIARY_NAME],
        ifsc: state && state[FIELD_NAMES.IFSC]?.toUpperCase(),
    };
};

export  const updateProfile = (fields: IBankAccountProfile & ILoanProfile) => {
    const profile = {
        loanRequest: {},
        bankAccounts: [],
    };
    Object.keys(fields).forEach((key) => {
        if (key === FIELD_NAMES.IFSC ||
            key === FIELD_NAMES.BENEFICIARY_NAME ||
            key === FIELD_NAMES.ACCOUNT_NUMBER) {
            profile["bankAccounts"] = [{
                ...profile.bankAccounts[0],
                [key]: fields[key],
            }];
        } else {
            profile["loanRequest"] = {
                ...profile.loanRequest,
                [key]: fields[key],
            };
        }
    });
    return profile;
};

export const getMinMaxLoanDetails = (loanDetails: ILoanBoundary) => {
    return {
        amount: {
            min: loanDetails["amount_range"][0],
            max: loanDetails["amount_range"][1],
        },
        tenure: {
            min: loanDetails["tenure_months_range"][0],
            max: loanDetails["tenure_months_range"][1],
        },
    };
};
